var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ValidationObserver", {
    ref: "observer",
    attrs: { tag: "div", slim: true },
    scopedSlots: _vm._u(
      [
        {
          key: "default",
          fn: function(ref) {
            var invalid = ref.invalid
            return [
              _c(
                "form",
                {
                  key: _vm._uid,
                  on: {
                    submit: function($event) {
                      $event.preventDefault()
                      return _vm.submit($event)
                    }
                  }
                },
                [
                  _c("el-error", { attrs: { error: _vm.error } }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "content", attrs: { name: "default" } },
                    [_vm._t("default")],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "d-flex mt-30 w-100 form-footer" },
                    [
                      _c("el-button", {
                        class: [_vm.buttonClass, "mr-auto"],
                        attrs: {
                          loading: _vm.loading,
                          success: _vm.success,
                          loadingLabel: _vm.loadingText,
                          successLabel: _vm.successText,
                          defaultLabel: _vm.submitText,
                          disabled: invalid || _vm.disabled
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ]
          }
        }
      ],
      null,
      true
    )
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }